// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
} from '../../utils/Styles/DataBoxStyles';
import DollarOutput from '../../utils/DollarOutput';
import { StyledMobileBoxLabel } from '../../utils/MobileDataBox';

const StyledTitle = styled(StyledMobileBoxItemRow)`
  font-size: 18px;
  color: #b6266b;
  max-width: 100%;
`;

const StyledItem = styled(StyledMobileBoxItemRow)`
  font-weight: 400;
  max-width: 100%;
`;

const BookingOptionListMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  content,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onBookingOptionEdit,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  handleHours,
}) => {
  const renderDuration = item =>
    item.duration ? `(${item.duration} minutes)` : '';
  const getIconName = item =>
    item.pricingModel === 'person' ? 'user' : 'users';

  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {content.map(item => (
        <StyledMobileBoxItem key={item.id}>
          <StyledMobileBoxLabel onClick={() => onBookingOptionEdit(item)}>
            <i className='fas fa-pencil-alt' />
          </StyledMobileBoxLabel>
          <StyledTitle>{item.title}</StyledTitle>
          <StyledItem>
            <i className={`fas fa-${getIconName(item)}`} />{' '}
            <DollarOutput value={item.price} /> {renderDuration(item)}
          </StyledItem>
          <StyledItem>{item.description}</StyledItem>
          <StyledItem>{handleHours(item.hours)}</StyledItem>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default BookingOptionListMobile;
